import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';

const initialState = {
  previewFileStatus: null,
  isLoading: false,
  succesMsg: null,
  errorMsg: null,
};

const addPrviewFile = createSlice({
  name: 'addPrviewFile',
  initialState,
  reducers: {
    fetch: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.isLoading = false;
      state.errorMsg = action.payload;
    },
    postPreviewFileData: (state, action) => {
      state.previewFileStatus = action.payload?.status;
      state.isLoading = false;
      state.succesMsg = action.payload?.message;
      state.errorMsg = null;
    },
    resetPreviewFileData: (state) => {
      state.previewFileStatus = null;
      state.isLoading = false;
      state.succesMsg = null;
      state.errorMsg = null;
    },
  },
});

const {fetch, fetchError, postPreviewFileData, resetPreviewFileData} = addPrviewFile.actions;

export default addPrviewFile.reducer;

export const postPreviewFile = (passValues) => {
  return (dispatch) => {
    dispatch(fetch());
    httpPost(`data-manager/execution/downloadfile`, passValues)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postPreviewFileData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetPreviewFile = () => {
  return (dispatch) => {
    dispatch(resetPreviewFileData());
  };
};
